<template>
  <b-modal ref="modal" hide-footer centered title="Add New Page">
    <b-form @submit.prevent="save">
      <b-form-group label="Title:">
        <b-form-input
          autofocus
          v-model="$v.title.$model"
          :class="{ 'is-invalid': $v.title.$error }"
          :disabled="inProgress"
        />
        <b-form-invalid-feedback v-if="!$v.title.required">Title is required</b-form-invalid-feedback>
        <b-form-invalid-feedback
          v-if="!$v.title.isUnique"
        >There's a Table with the same title already exists</b-form-invalid-feedback>
        <b-form-invalid-feedback
          v-if="!$v.title.alphaNum"
        >Table title accepts only alphanumerics and can not start with number or dash sign</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <b-form-checkbox v-model="createTable" :disabled="inProgress">
          <span>Create Table</span>
        </b-form-checkbox>
      </b-form-group>
      <div>
        <b-button type="submit" variant="primary" :disabled="inProgress">
          <span>Save</span>
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import { required, helpers } from 'vuelidate/lib/validators'
const alphaNum = helpers.regex('alphaNum', /^[A-Za-z][A-Za-z0-9_-\s]*$/)
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'

export default {
  props: ['tabs'],
  data() {
    return {
      title: null,
      template: null,
      createTable: false,
      inProgress: false,
    }
  },
  computed: {
    ...mapState(['dataGrid_options']),
  },
  methods: {
    open(template) {
      this.template = template ? template : null
      if (this.$refs.modal) this.$refs.modal.show()
    },
    hide() {
      if (this.$refs.modal) this.$refs.modal.hide()
    },
    async save() {
      if (this.inProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProgress = true

      const currentTab = await new Promise(resolve => {
        const data = {
          title: this.title,
          template: this.template,
        }

        db.tabs.create(data, newTabKey => {
          resolve(newTabKey)
        })
      })

      if (this.createTable) {
        const gridId = this.$sanitize(this.title)
        const gridData = {
          title: this.title,
          storageType: 'dashboard',
          source: this.$sanitize(this.title),
          tab: currentTab,
          filterVisible: null,
          overflow: 'height:auto',
          gsOptions: {
            x: 0,
            y: 0,
            w: 24,
            h: 18,
          },
        }

        await db.dataGrid.widget.createNew(gridData)
        eventBus.$emit('dataGridAdded', gridId)
      }

      this.title = null
      this.createTable = false
      this.inProgress = false

      this.$emit('onTabAdded', currentTab)
      this.hide()
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
  },
  validations: {
    title: {
      required,
      isUnique(value) {
        if (!this.title) return true
        if (!this.createTable) return true
        if (!this.dataGrid_options) return true

        const grids = Object.keys(this.dataGrid_options)

        if (!grids.includes(this.$sanitize(this.title))) return true

        return false
      },
      alphaNum,
    },
  },
}
</script>
